"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function Compose({ components, children }) {
    let ComponentWithWrappers = children;
    const loopStart = components.length - 1;
    for (let i = loopStart; i >= 0; i--) {
        const mycomponent = components[i];
        if (Array.isArray(mycomponent)) {
            ComponentWithWrappers = react_1.default.createElement(mycomponent[0], mycomponent[1], ComponentWithWrappers);
        }
        else {
            ComponentWithWrappers = react_1.default.createElement(mycomponent, null, ComponentWithWrappers);
        }
    }
    return ComponentWithWrappers;
}
exports.default = Compose;
